

















import { defineComponent, getCurrentInstance } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import meeting from '@/renderer/scripts/utils/meeting';
import { meetingPhoneLogin } from '@/renderer/scripts/utils/meeting/autoLoginInMeeting';
import tips from '@/renderer/scripts/utils/tips';
import { CONSTANT_URL } from '@/renderer/scripts/http';

export default defineComponent({
  props: {
    show: Boolean,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const methods = {
      async loginWithMeetingPhone() {
        if (!meeting.canUseGetPhoneNumber) {
          tips.warning(i18n_t('当前会议版本不支持自动获取手机号，请升级后使用或切换至手机号登录'));
          return;
        }
        await meetingPhoneLogin();
      },
      // 打开服务协议
      openAgreementPage(urlType: 'serviceAgreement' | 'privacyAgreement') {
        if (urlType === 'serviceAgreement') {
          dispatchRouter(CONSTANT_URL.serviceAgreement);
        } else if (urlType === 'privacyAgreement') {
          dispatchRouter(CONSTANT_URL.privacyAgreement);
        }
      },
    };
    return {
      ...methods,
    };
  },
});
